export const affiliateOfferZones = {
    EXIT_MODAL: "exitModal",
    THANK_YOU: "thankYou",
    HOME_PAGE: "homePage",
    LISTING_PAGE: "listingPage",
    COMPARISON_PAGE: "comparisonPage",
    LOCATION_BANNER: "locationBanner",
    PAGE_BUILDER: "pageBuilder",
    SWITCH_UI_LISTING: "switchUiListing",
    EXIT_FORM_MODAL: "exitFormModal",
} as const;

export type AffiliateOfferZone =
    typeof affiliateOfferZones[keyof typeof affiliateOfferZones];

export const SHARED_FIELDS_CODENAME = [
    "firstName",
    "lastName",
    "phoneNumber",
    "email",
    "streetAddress",
    "zipCode",
    "companyName",
];
export const COMMON_FIELDS_CODENAME = [
    "streetAddress",
    "zipCode",
    "companyName",
];

export const BACKEND_VALIDATION_ERRORS_MESSAGES = {
    INVALID_PHONE_NUMBER_FORMAT: {
        en: "Invalid Phone Number Format",
        es: "Número de teléfono con formato inválido",
        ar: "تنسيق رقم الهاتف غير صالح",
    },
    INVALID_GOOGLE_CAPTCHE: {
        en: "INVALID GOOGLE ReCAPTCHE",
        es: "Google ReCaptcha inválido",
        ar: "رمز التحقق من Google (reCAPTCHA) غير صالح",
    },
    STRING_TOO_SHORT_ERROR: {
        en: "String too short",
        es: "Cadena demasiado corta",
        ar: "النص قصير جدًا",
    },
    STRING_TOO_LONG_ERROR: {
        en: "String too long",
        es: "Cadena demasiado larga",
        ar: "النص طويل جدًا",
    },
    STRING_IS_BAD_WORD_ERROR: {
        en: "String is bad word",
        es: "Cadena tiene una mala palabra",
        ar: "النص يحتوي على كلمة غير لائقة",
    },
    NOT_VALID_FULL_NAME_ERROR: {
        en: "Bad name",
        es: "Nombre inválido",
        ar: "اسم غير صالح",
    },
    SIMILAR_FIRSTNAME_LASTNAME_ERROR: {
        en: "First and last names are similar",
        es: "Los nombres y apellidos son similares",
        ar: "الاسم الأول واسم العائلة متشابهان",
    },
    FULLNAME_TOO_SHORT_ERROR: {
        en: "First and last names are too short",
        es: "Los nombres y los apellidos son demasiado breves",
        ar: "الاسم الأول واسم العائلة قصيران جدًا",
    },
    NOT_VALID_EMAIL_ERROR: {
        en: "Invalid email",
        es: "Correo electrónico inválido",
        ar: "البريد الإلكتروني غير صالح",
    },
    NOT_VALID_ZIP_CODE_ERROR: {
        en: "Invalid zip code",
        es: "Código postal inválido",
        ar: "الرمز البريدي غير صالح",
    },
    NOT_VALID_PHONE_NUMBER_ERROR: {
        en: "Invalid phone number",
        es: "Número de teléfono inválido",
        ar: "رقم الهاتف غير صالح",
    },
    NOT_VALID_STREET_ADDRESS_ERROR: {
        en: "Invalid street address",
        es: "Dirección de domicilio inválida",
        ar: "عنوان الشارع غير صالح",
    },
};
